import React from 'react';
import { useClerk, useUser } from "@clerk/clerk-react";
import { useSelector } from "react-redux";

const Unauthorized = () => {
    const { signOut } = useClerk();
    const { user } = useUser();
    const auth = useSelector((s) => s.auth);

    return (
        <div className="flex items-center justify-center min-h-screen w-full bg-(--surface-base) text-(--neutral-900)">
            <div className="flex flex-col items-center justify-center rounded-xl shadow-lg max-w-md p-10 w-full mx-4 border border-(--neutral-200) dark:border-(--neutral-700) bg-(--surface-panel) text-(--neutral-800) dark:text-(--neutral-800)">
                <svg
                    width="64"
                    height="64"
                    fill="none"
                    viewBox="0 0 24 24"
                    className="mb-4 text-(--color-destructive)"
                >
                    <circle
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="2"
                        fill="color-mix(in srgb, var(--color-destructive) 12%, transparent)"
                    />
                    <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5"
                    />
                </svg>

                <h2 className="text-3xl font-bold mb-2 text-(--neutral-900) dark:text-(--neutral-800)">
                    Unauthorized
                </h2>
                <p className="text-lg mb-4 text-center text-(--neutral-600) dark:text-(--neutral-600)">
                    You do not have permission to access this page.
                    <br />
                    Please contact your Admin for access.
                </p>

                {import.meta?.env?.DEV && (
                    <div className="w-full rounded-lg border border-(--neutral-200) bg-(--neutral-50) p-3 text-xs text-(--neutral-700) mb-3">
                        <div className="font-semibold mb-1">Debug (dev only)</div>
                        <div>rolesStatus: {String(auth?.rolesStatus)}</div>
                        <div>roles: {(auth?.roles || []).join(", ") || "(empty)"}</div>
                        <div>rolesUserId: {String(auth?.rolesUserId || "")}</div>
                        <div>backendUserId: {String(auth?.backendUserId ?? "")}</div>
                        <div>rolesError: {String(auth?.rolesError || "")}</div>
                    </div>
                )}

                <button
                    onClick={() => signOut()}
                    className="bg-(--color-primary) text-white px-6 py-3 rounded-md font-semibold mt-2 hover:opacity-90 transition"
                >
                    Go to Sign In
                </button>
            </div>
        </div>
    );
};

export default Unauthorized;